import { render } from "./chatLottie.vue?vue&type=template&id=c0335642&scoped=true&ts=true"
import script from "./chatLottie.vue?vue&type=script&lang=ts"
export * from "./chatLottie.vue?vue&type=script&lang=ts"

import "./chatLottie.vue?vue&type=style&index=0&id=c0335642&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0335642"]])

export default __exports__